module.exports = __webpack_public_path__ + "img/b895c0d.png";